import classNames from 'classnames';
import Icon from 'components/styleguide/icon/Icon';
import MicroButton from 'components/styleguide/micro_button/MicroButton';
import React from 'react';

const styles = require('./Chip.module.scss');

export type ChipVariant = 'primary' | 'secondary';
export type ChipContext = 'talent' | 'company';

export interface ChipProps {
  children: React.ReactNode;
  className?: string;
  context?: ChipContext;
  highlighted?: boolean;
  iconLeft?: string;
  iconRight?: string;
  iconRightLabel?: string;
  onIconRightClick?: () => void;
  variant?: ChipVariant;
}

const Chip: React.FC<ChipProps> = ({
  children,
  className,
  context = 'talent',
  highlighted = false,
  iconLeft,
  iconRight,
  iconRightLabel = '',
  onIconRightClick,
  variant = 'primary',
}) => {
  const isSecondary = variant === 'secondary';
  const leftIconColor = isSecondary ? 'neutral-border-darker' : `${context}-border-base`;
  const microButtonContext = isSecondary ? 'neutral' : context;

  return (
    <span
      className={classNames(
        styles.chip,
        styles[context],
        styles[variant],
        { [styles.highlighted]: highlighted },
        className,
      )}
    >
      {iconLeft && (
        <Icon name={iconLeft} size="sm" color={leftIconColor} aria-hidden="true" />
      )}
      <span className={styles.label}>{children}</span>
      {iconRight && (
        <MicroButton
          iconName={iconRight}
          context={microButtonContext}
          aria-label={iconRightLabel}
          onClick={onIconRightClick}
        />
      )}
    </span>
  );
};

export default Chip;
